import request from '@utils/request'
import axios from 'axios'
import { prominent } from 'color.js'

export const getBase64 = file =>
    new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
    })
export const getFileId = fileUrl => {
    if (fileUrl) {
        const modifier = fileUrl.replace('//', '').split('/')
        const modifier2 = modifier?.length > 0 ? modifier[1]?.split('?') : ''
        if (Array.isArray(modifier2) && modifier2.length) return modifier2[0]
        return null
    }
    return null
}
export const uploadFileHelper = async (file, route) => {
    const selectedFile = file?.originFileObj || file
    let localFile = null
    let resultFileId = null
    let uploadResult = null
    if (selectedFile) {
        localFile = await getBase64(file?.originFileObj || file)

        const uploadLink: any = await request.get(`${route}${file.name ? '?fileName=' + file.name : ''}`)
        uploadResult = uploadLink?.result || uploadLink
        if (uploadResult?.file && uploadResult?.uploadURL) {
            const response = await axios.put(uploadResult.uploadURL, selectedFile, {
                headers: {
                    'Content-Type': 'multipart/form-data;'
                }
            })
            if (response?.status === 200) {
                resultFileId = uploadResult?.file
            }
        }
    }
    return {
        localFile,
        resultFileId,
        uploadResult
    }
}

export const uploadMultiFileHelper = async (files, route) => {
    const images = []
    const localFiles = []
    const uploadResult = []
    for (let index = 0; index < files.length; index++) {
        const imageFile = await uploadFileHelper(files[index], route)
        if (imageFile.resultFileId) {
            images.push(imageFile.resultFileId)
            localFiles.push(imageFile.localFile)
            uploadResult.push(imageFile.uploadResult)
        }
    }
    return { images, localFiles, uploadResult }
}

export const getColorsFromImage = async image => {
    if (image) {
        function componentToHex(c) {
            const hex = c.toString(16)
            return hex.length == 1 ? '0' + hex : hex
        }
        function rgbToHex(r, g, b) {
            return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b)
        }
        const colors = await prominent(image?.file ? URL.createObjectURL(image?.file) : image, { amount: 8 })
        return {
            imageColors: typeof colors !== 'string' ? colors.map(i => rgbToHex(i[0], i[1], i[2])) : [],
            localFile: image?.file ? URL.createObjectURL(image?.file) : image
        }
    }
}
